import { createGlobalStyle, css } from 'styled-components';
import { media, Theme } from '@minecraft.themes';
import { mapStyles } from '@minecraft.utils';
import Link from './Link';

type Props = {
  theme: Theme;
};

function generateMediasFontSize(props) {
  return mapStyles(
    Object.keys(props.theme.typography.body.size),
    (size) => css`
      ${media[size]`
        font-size: ${props.theme.typography.body.size[size].fontSize}
      `};
    `
  );
}

function generateHeadersStyles(props) {
  return mapStyles(
    Object.keys(props.theme.typography.header.type),
    (headerType) => css`
      ${headerType} {
        color: ${props.theme.typography.header.type[headerType].color};
        font-weight: ${props.theme.typography.header.type[headerType].fontWeight};
        font-size: ${props.theme.typography.header.type[headerType].fontSize};
      }
    `
  );
}

export default createGlobalStyle`
  body {
    color: ${(props: Props) => props.theme.typography.body.color};
    font-family: ${(props: Props) => props.theme.typography.body.font};
    font-weight: ${(props: Props) => props.theme.typography.body.fontWeight};
    -webkit-font-smoothing: antialiased;

    ${(props) => generateMediasFontSize(props)};
  }

  ${(props) => generateHeadersStyles(props)};

  ${Link}

  // Braze themeing overrides
  .ab-feed .ab-feed-buttons-wrapper {
    background-color: ${(props) => props.theme.globalHeader.colors.braze} !important;
  }

  // use this to leave an element in the dom for
  // screen readers but hide it from what people can see
  .visually-hidden {
    position: absolute;
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0,0,0,0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }
`;
